import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "gps"
const GpsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 20h9.006A3.004 3.004 0 0 0 22 16.991V7.009A2.995 2.995 0 0 0 19.006 4H4.994A3.004 3.004 0 0 0 2 7.009v9.982A2.995 2.995 0 0 0 4.994 20H7v-9a1 1 0 0 1 1-1h6V6.5l5.5 5-5.5 5V13h-4v7Z"
          />
        </svg>
      }
    </span>
  )
}
export default GpsIcon
